import './vertical-tabs';
import './mobile-menu';
// import './custom-search';
// import './custom-search-cs';
import './progressBar';
// import { getPosition } from "../helpers/getPosition";
// import { counter } from "./counter";
// import { checkBlogProgress } from "../helpers/blogProgress";
// import './onScroll';
import 'animate.css';
// import $ from 'jquery';



import AOS from 'aos';
//Animate On Scroll
AOS.init();

const nav = document.querySelector("#nav");
const scrollToTop = document.querySelector('.scroll-to-top');
const SCROLL_FROM_TOP_VALUE = 10;
const singlePage = document.querySelector('.single');
const pageHeight = singlePage ? singlePage.clientHeight - window.innerHeight: 20;
const progressBar = document.querySelector('.blog-progress');

// COUNTER

// const counterSection = document.querySelector(".counter");
// const count = document.querySelector(".arena-counter");

// function checkCounter(scrollPosition) {
//   const counterStarted = +count.innerHTML !== 0;
//   const counterPosition = getPosition(counterSection);
//   const customScrollPosition = scrollPosition + 250;
//   const scrolledToCounter = customScrollPosition >= counterPosition.y;

//   if (scrolledToCounter && !counterStarted) {
//     counter().start();
//   }
// }



window.addEventListener("scroll", (e) => {
  /* const scrollFromTop = window.scrollY;

  checkBlogProgress(scrollFromTop, pageHeight, !!singlePage, progressBar);

  // if (count) checkCounter(scrollFromTop);

  if (scrollFromTop <= SCROLL_FROM_TOP_VALUE)
    nav.classList.remove("scrolled");
    if (progressBar) progressBar.classList.remove('show');
    if (scrollToTop) scrollToTop.classList.remove("show")
  if (scrollFromTop > SCROLL_FROM_TOP_VALUE) {
    if (scrollToTop) scrollToTop.classList.add("show");
    if (progressBar) progressBar.classList.add('show');

    const navHasSctolledClass = nav.classList.contains("scrolled");
    if (!navHasSctolledClass) nav.classList.add("scrolled");
  } */
});

// TRY TO Throttle Scroll Events LATER !!!!!!!!!!!!

/* Footer nav */

const footerPrimaryMenuToggle = document.querySelectorAll('.footer-primary .dropdown-toggle');
footerPrimaryMenuToggle.forEach(dropdown => {
  dropdown.addEventListener('click', (e) => {
    console.log('log e', e);
    e.preventDefault();
    const dropdownMenu = e.target.nextElementSibling;
    const isHiddenMenu = dropdownMenu.classList.contains('hide');

    if (isHiddenMenu) {
      dropdownMenu.classList.remove('hide');
    } else {
      dropdownMenu.classList.add('hide');
    }
  })
})


// Function to initialize the tabs block
const initTabsBlock = (blockClass) => {
  const tabsNav = document.querySelector(`.${blockClass} .tabs__nav`);
  const tabsNavItems = document.querySelectorAll(`.${blockClass} .tabs__nav-item`);
  const panels = document.querySelectorAll(`.${blockClass} .tabs__panel`);

  if (!tabsNav || !tabsNavItems.length || !panels.length) {
    return; // Exit if any of the required elements are missing
  }

  // Set active nav element
  const setActiveItem = (elem) => {
    tabsNavItems.forEach((el) => {
      el.classList.remove('js-active');
    });
    elem.classList.add('js-active');
  };

  // Find active nav element
  const findActiveItem = () => {
    let activeIndex = 0;
    tabsNavItems.forEach((el, index) => {
      if (el.classList.contains('js-active')) {
        activeIndex = index;
      }
    });
    return activeIndex;
  };

  // Find active nav element parameters: left coord, width
  const findActiveItemParams = (activeItemIndex) => {
    const activeTab = tabsNavItems[activeItemIndex];
    const activeItemWidth = activeTab.offsetWidth - 1;
    const activeItemOffset_left = activeTab.offsetLeft;
    return [activeItemWidth, activeItemOffset_left];
  };

  // Appending decoration block to an active nav element
  const appendDecorationNav = () => {
    const decorationElem = document.createElement('div');
    decorationElem.classList.add('tabs__nav-decoration');
    decorationElem.classList.add('js-decoration');
    tabsNav.append(decorationElem);
    return decorationElem;
  };

  // Appending styles to decoration nav element
  const styleDecorElem = (elem, decorWidth, decorOffset) => {
    elem.style.width = 'auto';
    const textWidth = elem.offsetWidth;
    elem.style.width = `${Math.max(textWidth, decorWidth)}px`;
    elem.style.transform = `translateX(${decorOffset}px)`;
  };

  // Find active panel
  const findActivePanel = (index) => {
    return panels[index];
  };

  // Set active panel class
  const setActivePanel = (index) => {
    panels.forEach((el) => {
      el.classList.remove('js-active');
    });
    panels[index].classList.add('js-active');
  };

  // Onload function
  window.addEventListener('load', () => {
    const activeItemIndex = findActiveItem();
    const [decorWidth, decorOffset] = findActiveItemParams(activeItemIndex);
    const decorElem = appendDecorationNav();
    styleDecorElem(decorElem, decorWidth, decorOffset);
    findActivePanel(activeItemIndex);
    setActivePanel(activeItemIndex);
  });

  // Click nav item function
  tabsNav.addEventListener('click', (e) => {
    if (e.target.classList.contains('tabs__nav-item')) {
      const clickedTab = e.target;
      const activeItemIndex = Array.from(tabsNavItems).indexOf(clickedTab);
      setActiveItem(clickedTab);
      const [decorWidth, decorOffset] = findActiveItemParams(activeItemIndex);
      const decorElem = tabsNav.querySelector('.js-decoration');
      styleDecorElem(decorElem, decorWidth, decorOffset);
      findActivePanel(activeItemIndex);
      setActivePanel(activeItemIndex);
    }
  });
};

// Call the function to initialize the tabs block for each block separately
initTabsBlock('tabs-block');
initTabsBlock('compare-block');
initTabsBlock('integration-tabs-block');
initTabsBlock('compare-two-block');
initTabsBlock('team-tabs-block');
initTabsBlock('faq-tabs-block');
initTabsBlock('blog-tabs-block');

//copy permalink on click
document.addEventListener('DOMContentLoaded', function() {
  const copyLinkAnchor = document.getElementById('copy-link-anchor');

  if (copyLinkAnchor) {
      copyLinkAnchor.addEventListener('click', function(event) {
          event.preventDefault();
          const permalink = this.getAttribute('data-permalink');

          // Create a temporary input element to copy the permalink to the clipboard
          const tempInput = document.createElement('input');
          tempInput.value = permalink;
          document.body.appendChild(tempInput);
          tempInput.select();
          document.execCommand('copy');
          document.body.removeChild(tempInput);

          // Add any desired feedback to indicate that the link has been copied
          alert('Permalink copied to clipboard!');
      });
  }
});

const getInTouchBtn = document.querySelector('body .get-in-touch');
const contactModal = document.querySelector('body .contact-modal');
const contactModalClose = document.querySelector('body .contact-modal-close');

getInTouchBtn && getInTouchBtn?.addEventListener('click', () => {
  contactModal.style.display = 'block';
  contactModal.classList.add('active');
});

contactModalClose && contactModalClose?.addEventListener('click', () => {
  contactModal.style.display = 'none';
  contactModal.classList.remove('active')
});

//faq cards
$(document).ready(function () {
  // Initially, hide all the item descriptions
  $('.faq__card-description').hide();
  $('.faq__card').find('.close').hide();
  $('.faq__card').find('.open').show();

  // Add click event to each item
  $('.faq__card').click(function () {

    $(this).siblings().find('.faq__card-description').slideUp();
    $(this).siblings().find('.close').hide();
    $(this).siblings().find('.open').show();

    // Toggle the item description of the clicked item
    $(this).find('.faq__card-description').slideToggle('fast');

    // Add and remove the 'active' class
    $(this).toggleClass('active').siblings().removeClass('active');
    if ($(this).hasClass('active')) {
      $(this).find('.close').show();
      $(this).find('.open').hide();
    } else {
      $(this).find('.close').hide();
      $(this).find('.open').show();
    }
  });
});
